import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCurrentUser } from "./UserContext";
import { resolveRouteForCurrentUser } from "./utils/authRouting";

function AuthenticatedRouter({ children }) {
  const { currentUser, loading } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect while loading
    if (loading) return;

    // Don't redirect if no user
    if (!currentUser) return;

    // Public browsing pages — any role can view these, never redirect away
    const isProviderProfilePage = /^\/provider\/\d+/.test(location.pathname);
    const isClaimPage =
      location.pathname === "/claim" || location.pathname === "/claim-referral";
    if (isProviderProfilePage || isClaimPage) return;

    // Get the route this user should be on
    const expectedRoute = resolveRouteForCurrentUser(currentUser);

    if (
      currentUser.userType === "PROVIDER" &&
      currentUser.providerVerificationStatus !== "VERIFIED" &&
      location.pathname === "/ProviderProfile"
    ) {
      navigate(expectedRoute, { replace: true });
      return;
    }

    // If user should be on a different route, redirect
    if (expectedRoute && expectedRoute !== location.pathname) {
      navigate(expectedRoute, { replace: true });
    }
  }, [currentUser, loading, location.pathname, navigate]);

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
          <p className="text-gray-700">Loading your account...</p>
        </div>
      </div>
    );
  }

  return children;
}

export default AuthenticatedRouter;
